import React, { useState } from 'react'
import { Button } from '@boulevard/blvd-ui'
import { observer } from 'mobx-react-lite'
import { appRootStore } from '../stores'
import { appService, popupService } from '../services'

export const AuthenticateButton: React.FC = observer(() => {
  const integrationsStore = appRootStore.getIntegrationsStore()
  const [error, setError] = useState<string>()

  const onAuthClick = async () => {
    setError(undefined)
    const url = integrationsStore.getFbAuthenticateUrl()
    const win = popupService.popupCenter(url, 'Login', 900, 500)

    window.processFbCallBack = async (
      code: string,
      fbBusinessId: string
    ): Promise<boolean> => {
      if (win) {
        win.close()
      }
      try {
        await appService.exchangeFbCodeForAccessToken(code, fbBusinessId)
        await integrationsStore.reloadDataFromApi()

        return true
      } catch (err) {
        const message = 'Error processing Facebook authentication callback'
        console.error(message, err)
        setError(err instanceof Error ? message + ': ' + err.message : message)

        return false
      }
    }
  }

  return (
    <>
      {error && <p className="error-message">{error}</p>}
      <Button
        className="margin-b_40"
        theme="primary"
        padding="standard"
        type="button"
        size="large"
        contentAlignment="center"
        onClick={onAuthClick}
      >
        Connect Social Page
      </Button>
    </>
  )
})
